import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/consciousness.pdf'; 
import { Helmet } from 'react-helmet';

function Consciousness() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		   	<var>S&#228;mtliche schriften und briefe series VI volume 4</var><br />
        Deutsche Akademie der Wissenschaften (ed)<br />
        pp 1473-1474<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: 1683 - 1685?<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (72k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On Consciousness and Memory</title>
            <meta name="description" content="An English translation of ON CONSCIOUSNESS AND MEMORY by Gottfried Wilhelm Leibniz, from 1683 - 1685?" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON CONSCIOUSNESS AND MEMORY</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>A VI 4, 1473</b>]<br /><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Consciousness is memory of  our actions. Descartes therefore claims that that no demonstration can be trusted because every demonstration requires the memory of previous propositions, with regard to which we could perhaps be deceived by the power of some evil genius.  But if we extend the pretext of doubting to this point, we cannot even trust our consciousness of the present, because memory is always involved, since nothing is present, absolutely speaking, for more than a moment.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Writings or notes assist the memory when demonstrating, but nothing better confirms that there is no evil genius who deceives us by adulterating them than success, that is, a successful outcome, into which the confidence of all our certainty is ultimately resolved, nor can a very clear dream be distinguished from wakefulness in any other way.<br /><br />

                [<b>A VI 4, 1474</b>]<br />
                <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Consciousness of vision, of appearance, of pleasure and pain is given; consciousness of truth, of certainty, of justice or of all those things which must be inferred, is not given, and therefore cannot be sworn to.
                <br /><br /><br />
		
                &#169; Lloyd Strickland 2005<br />
                With gratitude to John Thorley for advice and suggestions
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Consciousness;
